const InputThoroughfare = ({ thoroughfare, handleInputThoroughfare }) => {
    return (
        <input
            id='thoroughfare-input'
            className='thoroughfare-input-style'
            value={thoroughfare}
            onChange={handleInputThoroughfare}
        />
    );
};

export default InputThoroughfare;